import {Http} from "@angular/http";
import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Router} from "@angular/router";
import {PaiementDto} from "@resources/resources";
import * as lodash from "lodash";

@Component({
  selector: 'rappelLabo-component',
  templateUrl: './rappelLabo.component.html',
  host: {'class': 'page'}
})
export class RappelLaboComponent {
  @Output() onReturn: EventEmitter<any> = new EventEmitter<any>();
  @Input() listPaiement: Array<PaiementDto>;
  @Input() firstPaiement: PaiementDto;
  @Input() total: number;
  showNext: boolean;
  paiementData: string;
  paiementError: boolean = false;
  totalAffichage: String;

  constructor(private router: Router, private http: Http) {
  }

  next() {
    let paiementIds = new Array<number>();
    lodash.forEach(this.listPaiement, function (paiement) {
      paiementIds.push(paiement.id);
    });

    this.http.post('/paiement-factures/api/paiement/initializeTransaction', paiementIds)
      .map(res => res.text())
      .subscribe(
        data => {
          //console.log(data);
          this.paiementData = data;
          this.paiementError = false;
          this.showNext = true;
        },
        () => {
          this.paiementData = null;
          this.paiementError = true;
          this.showNext = true;
        });
  }

  ngOnInit() {
    this.showNext = false;
    this.totalAffichage = new Number(this.total).toFixed(2);
  }

  return(agreed: boolean) {
    this.onReturn.emit(agreed);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/pages/cerba/pages/laboratoire/rappelLabo/rappelLabo.component.ts